/* section-reels-grid.js (4 Oct 2026)
   Reels / Social: inline videos without controls, and the arrows of "Card size: Large".
   Loaded with defer, only by reels-grid sections that have a video or are set to Large.
   Spec: planning/homepage-rebuild/reels-video/SPEC.md (addit workspace).
   Health events (founder, 4 Oct): Shopify.analytics.publish('addit_reel_video', {action, …}); the custom pixel
   "addit PDP events" forwards them to GA4 for visitors who allowed analytics. action = ready (load_ms: sources
   attached → enough buffered to play through), start (wait_ms: asked to play → first frame; preloaded),
   stall (rebuffer after start), fallback (reason; the section shows stills), error (a clip failed).
   How-to steps (sections/hp-steps.liquid, 5 Oct 2026) use the same engine through data-reels-* hooks: root
   [data-reels-root], [data-reels-video], [data-reels-media], [data-reels-item] (clip name in data-reels-clip),
   [data-reels-track]; their events carry surface = the root's data-reels-surface ("steps"). Reels markup has no
   data-reels-* hooks and steps markup no reels-grid__* classes, so every selector below still matches exactly the
   elements it matched before in a reels section, and reels events carry no surface field.
   Phones, steps only (6 Oct 2026, steps REVIEW M3; changed 9 Oct 2026, founder): a root with [data-reels-relay] gets,
   below 768 px, the SD-480p rendition first (a video's data-mp4-480, then 720p, then the official MP4: a 404 falls
   through). The clips get their sources one after another in step order (the next once the previous is fully buffered,
   failed, or got no new data for QUEUE_PHONE_MS). The LOADER — the first clip in step order that is in view and not
   yet fully buffered — may play while it loads (iOS Safari, the Instagram/Facebook webviews and Chrome on mobile data
   fetch media only for a playing video, so playing is what loads it there); every other clip plays only once fully
   buffered. The loader is worked out afresh on every view change and every finished buffer, never from a timer: on
   10 Oct a clip that lost a timed turn while out of view never started at all (founder: "sometimes they play and
   sometimes not"). On a fast line all four play
   together within seconds, on a slow one they join one by one and then keep looping together. A clip that plays to load
   stays behind its still until it is fully buffered and is then shown from its first frame, so a slow line shows calm
   stills that turn into looping videos one by one, never a flicker between still and video. On these phones a rebuffer shows
   the still until the data is there and never turns the section into stills, and there is no start timeout: a slow
   line gets its clips later, not never. Until 9 Oct only one clip played at a time (each once, then the next step),
   and two rebuffers meant stills.
   Autoplay blocked (iPhone Low Power Mode, Safari "Never Auto-Play", Firefox): since 10 Oct the section keeps its stills
   and starts the clips on the visitor's first tap, click or key press (a user gesture may start playback), instead of
   giving up for good; a second refusal after a gesture means stills. Reels have neither data-reels-relay nor
   data-mp4-480, so phoneMq stays null for them and every branch added for this runs the code path it ran before.
   Unboxing film (sections/hp-unboxing.liquid, 7 Oct 2026): one card on [data-reels-root] with surface "unboxing",
   no relay. Its video carries data-sharp-px="1400": the 720p file is then used up to 1400 device px (film width ×
   DPR) instead of SHARP_PX (a full-width 16:9 film is wider than any reels card); wider gets the top MP4. Reels and steps have no data-sharp-px, so
   attach() keeps SHARP_PX for them. */
(function () {
  'use strict';
  // A page with a reels strip AND a steps section with video includes this file twice: run once.
  if (window.__additReels) return;
  window.__additReels = true;

  var SEL_ROOT = '.reels-grid, [data-reels-root]';
  var SEL_VIDEO = '.reels-grid__video, [data-reels-video]';
  var SEL_MEDIA = '.reels-grid__media, [data-reels-media]';
  var SEL_ITEM = '.reels-grid__item, [data-reels-item]';
  var SEL_TRACK = '.reels-grid__track, [data-reels-track]';

  var PLAY_RATIO = 0.6;          // a card plays while at least 60 % of it is on screen
  var NEAR_MARGIN = '150% 0px';  // "near": start loading 1.5 screen heights before the section
  var LOAD_CAP_MS = 10000;       // wait for window.load, but never longer than this (review #4)
  var START_MS = 4000;           // a clip asked to play must be playing within this, else stills
  var QUEUE_MS = 6000;           // the preload queue moves to the next clip after this at the latest
  var QUEUE_PHONE_MS = 20000;    // steps on phones: the queue moves on after this long WITHOUT NEW DATA (it waits for a full buffer)
  var SHARP_PX = 600;            // card width x DPR (max 2) up to which the 720p file is used

  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var refreshers = [];

  function reduced() {
    return !!(reduceMq && reduceMq.matches);
  }

  // Chromium only (Safari and Firefox have no navigator.connection): Save-Data or a 3G-or-worse
  // estimate means stills only. navigator.connection.downlink is deliberately NOT used: Chrome
  // reports 1.45-1.6 Mbps on a fast desktop connection before it has measured anything.
  function slowNetwork() {
    var c = navigator.connection;
    return !!c && (c.saveData === true || /^(slow-2g|2g|3g)$/.test(c.effectiveType || ''));
  }

  var HANDLE = (/\/products\/([^/?#]+)/.exec(location.pathname) || [])[1] || '';
  function publish(data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        data.product_handle = HANDLE;
        Shopify.analytics.publish('addit_reel_video', data);
      }
    } catch (e) { /* analytics must never break playback */ }
  }

  function afterPageLoad(cb) {
    var started = false;
    function go() {
      if (started) return;
      started = true;
      if (window.requestIdleCallback) window.requestIdleCallback(cb, { timeout: 2000 });
      else setTimeout(cb, 200);
    }
    if (document.readyState === 'complete') go();
    else {
      window.addEventListener('load', go);
      setTimeout(go, LOAD_CAP_MS);
    }
  }

  /* ── Arrows (Card size: Large) ─────────────────────────────────────────── */
  function initNav(section) {
    var nav = section.querySelector('.reels-grid__nav');
    var track = section.querySelector('.reels-grid__track');
    if (!nav || !track) return;
    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');
    var raf = 0;
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 1;
      var prevOff = track.scrollLeft <= 1;
      var nextOff = track.scrollLeft >= max - 1;
      // Keep keyboard focus on the arrows when the focused one disables (review #5).
      if (nextOff && !next.disabled && document.activeElement === next && !prevOff) prev.focus();
      if (prevOff && !prev.disabled && document.activeElement === prev && !nextOff) next.focus();
      prev.disabled = prevOff;
      next.disabled = nextOff;
    }
    function schedule() {
      if (!raf) raf = requestAnimationFrame(update);
    }
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]');
      if (!btn) return;
      var item = track.querySelector('.reels-grid__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: Number(btn.getAttribute('data-dir')) * step, behavior: reduced() ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  /* ── Videos ────────────────────────────────────────────────────────────── */
  function initVideos(section) {
    // Steps on phones only: null for reels (no data-reels-relay), so phone() is false for them.
    var phoneMq = section.hasAttribute('data-reels-relay') && window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    function phone() {
      return !!(phoneMq && phoneMq.matches);
    }
    var cards = [].slice.call(section.querySelectorAll(SEL_VIDEO)).map(function (v) {
      var item = v.closest(SEL_ITEM);
      var cap = item && item.querySelector('.reels-grid__caption');
      var named = item && item.getAttribute('data-reels-clip');
      return { media: v.closest(SEL_MEDIA), video: v, loaded: false, dead: false, inView: false, timer: 0, next: null, started: false, stalls: 0,
        clip: named != null ? named : (cap && cap.firstChild ? cap.firstChild.textContent.trim() : ''), attachedAt: 0, askedAt: 0, wasReady: false, readySent: false };
    });
    if (!cards.length || !('IntersectionObserver' in window)) return;
    var mode = section.getAttribute('data-reels-load') === 'load' ? 'load' : 'near';
    var off = false;
    var blocked = false; // autoplay refused: waiting for the visitor's first gesture
    var queue = null;
    var busy = false;
    var playIO = null;
    var chain = false; // reels on a narrow track: preload one clip ahead instead of all (review #2)
    var surface = section.getAttribute('data-reels-surface');
    function send(data) {
      if (surface) data.surface = surface;
      publish(data);
    }

    function allowed() {
      return !off && !blocked && !reduced() && !slowNetwork();
    }

    // Autoplay was refused: keep the stills, wait for one user gesture, then try again inside it (a gesture may start
    // muted playback even in iPhone Low Power Mode). A refusal after the gesture means stills for good.
    var gestureTried = false;
    function blockedUntilGesture(card) {
      if (blocked || off) return;
      if (gestureTried) { sectionOff('autoplay_blocked'); return; }
      blocked = true;
      send(card ? info(card, { action: 'fallback', reason: 'autoplay_blocked', waiting: 'gesture' }) : { action: 'fallback', reason: 'autoplay_blocked', waiting: 'gesture' });
      cards.forEach(function (c) { pause(c); c.media.classList.remove('is-video'); });
      var evs = ['touchend', 'click', 'keydown'];
      function onGesture() {
        evs.forEach(function (n) { document.removeEventListener(n, onGesture, true); });
        gestureTried = true;
        blocked = false;
        send({ action: 'gesture_retry' });
        refresh(); // synchronous, so play() runs inside the gesture
      }
      evs.forEach(function (n) { document.addEventListener(n, onGesture, true); });
    }

    function info(card, extra) {
      var src = card.video.currentSrc || '';
      var d = { card: cards.indexOf(card) + 1, clip: card.clip, rendition: /HD-720p/.test(src) ? '720p' : (src ? '1080p' : '') };
      if (/SD-480p/.test(src) && card.video.hasAttribute('data-mp4-480')) d.rendition = '480p'; // steps only
      for (var k in extra) d[k] = extra[k];
      return d;
    }

    // Give the video its sources and start fetching. 720p (undocumented Shopify URL) first when it
    // is sharp enough, the official MP4 after it: a 404 on the first falls through to the second.
    function attach(card) {
      if (card.loaded || card.dead) return;
      var v = card.video;
      var need = card.media.getBoundingClientRect().width * Math.min(window.devicePixelRatio || 1, 2);
      var urls = [];
      var low = v.getAttribute('data-mp4-480'); // steps only
      var mid = v.getAttribute('data-mp4-720');
      var main = v.getAttribute('data-mp4');
      if (low && phone()) urls.push(low);
      var sharp = +v.getAttribute('data-sharp-px') || SHARP_PX; // unboxing only; everything else SHARP_PX
      if (mid && need <= sharp) urls.push(mid);
      if (main) urls.push(main);
      if (!urls.length) { kill(card); return; } // nit #10: never fetch an empty URL (= the page)
      card.loaded = true;
      card.attachedAt = performance.now();
      v.preload = 'auto';
      urls.forEach(function (url, i) {
        var s = document.createElement('source');
        s.src = url;
        s.type = 'video/mp4';
        if (i === urls.length - 1) s.addEventListener('error', function () { kill(card, 'source_error'); });
        v.appendChild(s);
      });
      v.load();
    }

    // One clip at a time, in card order; the next starts once the browser has enough of this one
    // (canplaythrough), stopped fetching it on purpose (suspend: iOS does not preload), failed,
    // or after QUEUE_MS. A clip asked to play jumps the queue (attach() from play()).
    // Steps on phones: the next only once this one is fully buffered — two downloads never share a slow line — or it
    // failed, or QUEUE_PHONE_MS passed without new data. The clip holding the turn is checked for playing at once.
    function pump() {
      if (busy || !queue || !allowed()) return;
      var card = queue.shift();
      while (card && (card.loaded || card.dead)) card = queue.shift();
      if (!card) return;
      busy = true;
      attach(card);
      var v = card.video;
      var ph = phone();
      var evs = ph ? ['progress', 'canplaythrough', 'suspend', 'error'] : ['canplaythrough', 'suspend', 'error'];
      var t = setTimeout(next, ph ? QUEUE_PHONE_MS : QUEUE_MS);
      function onEvent(e) {
        if (ph && e.type === 'progress') { clearTimeout(t); t = setTimeout(next, QUEUE_PHONE_MS); } // inactivity, not total time
        if (ph && e.type !== 'error' && !fullyBuffered(v)) return;
        next();
      }
      function next() {
        if (card.next !== next) return;
        card.next = null;
        clearTimeout(t);
        evs.forEach(function (n) { v.removeEventListener(n, onEvent); });
        busy = false;
        if (ph) refresh(); else pump(); // phones: a clip that lost the turn unbuffered is re-checked (refresh() ends with pump())
      }
      card.next = next;
      evs.forEach(function (n) { v.addEventListener(n, onEvent); });
      if (ph && mayPlay(card) && v.paused) play(card); // the new turn: on iOS and mobile data, playing is what fetches it
    }

    // Show the playing video over its still. Steps on phones: only once fully buffered, and the first time from frame 0,
    // which is the still — the switch is seamless.
    function reveal(card) {
      if (card.dead || card.media.classList.contains('is-video')) return;
      if (phone()) {
        if (!fullyBuffered(card.video)) return;
        if (!card.shown) { card.shown = true; try { card.video.currentTime = 0; } catch (e) { /* not seekable yet */ } }
      }
      card.media.classList.add('is-video');
    }

    function fullyBuffered(v) {
      var b = v.buffered;
      return b.length > 0 && isFinite(v.duration) && b.end(b.length - 1) >= v.duration - 0.25;
    }

    function arm(card) {
      if (card.timer) return;
      card.timer = setTimeout(function () {
        card.timer = 0;
        if (!document.hidden && card.inView && !card.dead) sectionOff('start_timeout', card);
      }, START_MS);
    }

    function disarm(card) {
      clearTimeout(card.timer);
      card.timer = 0;
    }

    function play(card) {
      if (card.dead || !allowed() || document.hidden) return;
      attach(card);
      var v = card.video;
      v.muted = true;
      if (!card.started && !card.askedAt) {
        card.askedAt = performance.now();
        card.wasReady = v.readyState >= 3;
      }
      if (v.readyState < 3 && !phone()) arm(card); // steps on phones: no start timeout (see the header)
      var p = v.play();
      if (p && p.catch) {
        p.catch(function (err) {
          var name = err && err.name;
          if (name === 'NotAllowedError') blockedUntilGesture(card); // Low Power Mode, "Never Auto-Play", Firefox block
          else if (name === 'NotSupportedError') kill(card, 'not_supported');
          // AbortError: we paused it before it started. Nothing to do.
        });
      }
    }

    function pause(card) {
      disarm(card);
      if (!card.video.paused) card.video.pause();
    }

    // Back to the still for good: stop, drop the sources, abort the download, remove the element.
    function kill(card, why) {
      if (card.dead) return;
      if (why) send(info(card, { action: 'error', reason: why }));
      card.dead = true;
      disarm(card);
      card.media.classList.remove('is-video');
      var v = card.video;
      v.pause();
      while (v.firstChild) v.removeChild(v.firstChild);
      v.removeAttribute('src');
      if (card.loaded) v.load();
      if (v.parentNode) v.parentNode.removeChild(v);
      if (card.next) card.next();
    }

    function sectionOff(reason, card) {
      if (off) return;
      send(card ? info(card, { action: 'fallback', reason: reason }) : { action: 'fallback', reason: reason });
      off = true;
      queue = null;
      cards.forEach(function (c) { kill(c); });
      if (playIO) playIO.disconnect();
    }

    // Steps on phones: the loader is the first clip in step order that is in view and not yet fully buffered.
    function loader() {
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (!c.dead && c.inView && !fullyBuffered(c.video)) return c;
      }
      return null;
    }
    // A card may play when it is in view, allowed and the tab is visible. Steps on phones also: it is fully buffered, or
    // it is the loader (play() gives it its source if the queue has not yet) — so only one clip fetches by playing.
    function mayPlay(card) {
      return !card.dead && card.inView && allowed() && !document.hidden &&
        (!phone() || fullyBuffered(card.video) || card === loader());
    }

    function refresh() {
      cards.forEach(function (card) {
        if (card.dead) return;
        if (mayPlay(card)) {
          if (card.video.paused) play(card);
        } else {
          pause(card);
        }
      });
      pump();
    }
    refreshers.push(refresh);

    cards.forEach(function (card) {
      var v = card.video;
      v.addEventListener('playing', function () {
        disarm(card);
        if (!card.started && card.askedAt) {
          send(info(card, { action: 'start', wait_ms: Math.round(performance.now() - card.askedAt), preloaded: card.wasReady }));
        }
        card.started = true;
        reveal(card);
        if (chain && queue) {
          var nextCard = cards[cards.indexOf(card) + 1];
          if (nextCard) { queue.push(nextCard); pump(); }
        }
      });
      v.addEventListener('waiting', function () {
        if (!card.inView || document.hidden) return;
        if (card.started && !fullyBuffered(v)) {
          // A rebuffer after the clip has started: the line cannot keep up. Hide it behind the
          // still; a second one means stills for the section (founder point 4, review #1).
          // Steps on phones: the still covers it and the clip goes on when the data is there (founder 9 Oct 2026).
          card.stalls++;
          send(info(card, { action: 'stall', stalls: card.stalls }));
          if (card.stalls >= 2 && !phone()) { sectionOff('stalls', card); return; }
          card.media.classList.remove('is-video');
        }
        if (!phone()) arm(card);
      });
      // Steps on phones: re-check a paused clip whenever its load state moves (fully buffered now, or metadata in), and
      // show a playing one once it is fully buffered.
      function recheck() {
        if (!phone()) return;
        if (!card.full && fullyBuffered(v)) { card.full = true; refresh(); } // the next clip in view becomes the loader
        if (v.paused && mayPlay(card)) play(card);
        else if (!v.paused && card.started) reveal(card);
      }
      ['loadedmetadata', 'canplaythrough', 'suspend', 'progress'].forEach(function (n) { v.addEventListener(n, recheck); });
      v.addEventListener('pause', function () { disarm(card); });
      v.addEventListener('error', function () { kill(card, 'media_error'); });
      v.addEventListener('canplaythrough', function () {
        if (card.readySent || !card.attachedAt) return;
        card.readySent = true;
        send(info(card, { action: 'ready', load_ms: Math.round(performance.now() - card.attachedAt) }));
      });
    });
    if (phoneMq) {
      if (phoneMq.addEventListener) phoneMq.addEventListener('change', refresh);
      else if (phoneMq.addListener) phoneMq.addListener(refresh);
    }

    afterPageLoad(function () {
      if (off) return;
      playIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var card = cards.filter(function (c) { return c.media === e.target; })[0];
          if (!card || card.dead) return;
          card.inView = e.isIntersecting && e.intersectionRatio >= PLAY_RATIO - 0.01; // same value as the threshold (review #3)
          if (phone()) return; // steps on phones: one view change can change the loader, so all cards are re-checked below
          if (mayPlay(card)) play(card);
          else pause(card);
        });
        if (phone()) refresh();
      }, { threshold: [0, PLAY_RATIO - 0.01] });
      cards.forEach(function (c) { playIO.observe(c.media); });

      function start() {
        if (reduced()) send({ action: 'fallback', reason: 'reduced_motion' });
        else if (navigator.connection && navigator.connection.saveData === true) send({ action: 'fallback', reason: 'save_data' });
        else if (slowNetwork()) send({ action: 'fallback', reason: 'slow_network', effective_type: navigator.connection.effectiveType || '' });
        // Stills of cards scrolled off to the side would otherwise wait for the horizontal scroll.
        [].slice.call(section.querySelectorAll('img[loading="lazy"]')).forEach(function (img) { img.loading = 'eager'; });
        var item = section.querySelector(SEL_ITEM);
        var track = section.querySelector(SEL_TRACK);
        chain = !!(item && track && track.clientWidth < item.getBoundingClientRect().width * 1.8);
        queue = chain ? cards.slice(0, 1) : cards.slice();
        pump();
      }
      if (mode === 'load') {
        start();
      } else {
        var nearIO = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          nearIO.disconnect();
          start();
        }, { rootMargin: NEAR_MARGIN });
        nearIO.observe(section);
      }
    });
  }

  function refreshAll() {
    refreshers.forEach(function (f) { f(); });
  }
  document.addEventListener('visibilitychange', refreshAll);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshAll(); });
  if (reduceMq) {
    if (reduceMq.addEventListener) reduceMq.addEventListener('change', refreshAll);
    else if (reduceMq.addListener) reduceMq.addListener(refreshAll);
  }
  if (navigator.connection && navigator.connection.addEventListener) {
    navigator.connection.addEventListener('change', refreshAll);
  }

  function boot(root) {
    [].slice.call(root.querySelectorAll(SEL_ROOT)).forEach(function (section) {
      if (section.__reels) return;
      section.__reels = true;
      initNav(section);
      initVideos(section);
    });
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
